module.exports = __webpack_public_path__ + "img/teacher_help_jobs_list.95c39663.png";